export default __webpack_public_path__ + "static/cpleahome-e378f13241b7a23e566ad961ae4546da.png";